import React, { useState, useRef } from "react";
import ImagePhotos from "../imagePhotos/imagePhotos";
import { defaultImage, urlList, urlPhoto } from "../URLlist/urlList";
import { saveConsoleLog } from "../../helpFunction/helpFunction";
import "./newDate.css";
import { propsMassage } from "../massage/massage";

type props = {
	changeImage: boolean;
	setChangeImage?: (e: boolean) => void;
	refresh: boolean;
	setRefresh: (e: boolean) => void;
	setMassage: (e: propsMassage) => void;
	newDateVisible: (e: boolean) => void;
	setSpinner: (e: boolean) => void;
};

function NewDate({ setRefresh, newDateVisible, refresh, setMassage, setSpinner }: props) {
	const [name, setName] = useState({ imie: "", nazwisko: "" });
	const [image, setImage] = useState<string | "">(defaultImage);
	const refDate = useRef<HTMLInputElement>(null);
	const [enabled, setEnabled] = useState(true);

	const sendPhoto = async (idItem: string) => {
		try {
			if (image === "") return;
			if (image === defaultImage) return;
			const urlP = `${urlPhoto}/${idItem}`;

			const form = new FormData();
			const data = await (await fetch(image)).blob();

			form.append("file", data, `photo`);
			await fetch(urlP, {
				method: "POST",
				body: form,
				credentials: "include",
			});
		} catch (error) {
			console.log(error);
			saveConsoleLog(JSON.stringify(`HTML error NewDate SendPhoto, ${error}`));
			setMassage({ text: "Błąd przy zapisie zdjecia - try again later", type: "err" });
		} finally {
			setSpinner(false);
			return;
		}
	};

	const validateData = () => {
		setEnabled(true);
		if (name.imie !== "" && name.nazwisko !== "" && refDate.current?.value !== "") {
			setEnabled(false);
			return true;
		} else {
			setEnabled(true);

			return false;
		}
	};

	async function zapisz() {
		try {
			setSpinner(true);
			const newItem = [];
			if (name.imie !== "" && name.nazwisko !== "" && validateData()) {
				newItem.push({
					imie: name.imie,
					nazwisko: name.nazwisko,
					data_ur: refDate.current?.value,
					last: "",
					dataLast: "",
				});

				fetch(urlList, {
					method: "post",
					credentials: "include",
					body: JSON.stringify(newItem[0]),
					headers: { "Content-Type": "application/json" },
				})
					.then((res) => {
						if (res.status === 200) {
							return res.json();
						} else {
							setMassage({ text: `ERROR - Błąd zapisu`, type: "err" });
						}
					})
					.then(async (res: { msg: string; id: string }) => {
						await sendPhoto(res.id);
						setMassage({ text: res.msg, type: "ok" });
						newDateVisible(false);
					})
					.catch((err) => {
						saveConsoleLog(JSON.stringify(`HTML error z NewDate Save, ${err}`));
						setMassage({ text: `ERROR - try again later`, type: "err" });
					});
			} else {
				setMassage({ text: "Prosze wypełnić wszystkie pola", type: "err" });
			}
		} catch (error) {
			saveConsoleLog(JSON.stringify(`HTML error z NewDate Save, ${error}`));
			newDateVisible(false);
		} finally {
			setSpinner(false);
			setRefresh(!refresh);
		}
	}

	function anuluj() {
		newDateVisible(false);
	}

	return (
		<>
			<div className="newDateContainer">
				<div className="newDateContainerView">
					<ImagePhotos image={image} setImage={setImage} setSpinner={setSpinner} />
					<div className={"newDateView"}>
						<p className={"newDateText"}>Imie</p>
						<input
							placeholder="IMIE"
							className={"editTextInput"}
							value={name.imie}
							onChange={(text) => {
								setName({ ...name, imie: text.target.value });
								validateData();
							}}
							onBlur={validateData}
						></input>
					</div>
					<div className={"newDateView"}>
						<p className={"newDateText"}>Nazwisko</p>
						<input
							placeholder="NAZWISKO"
							className={"editTextInput"}
							value={name.nazwisko}
							onChange={(text) => {
								setName({ ...name, nazwisko: text.target.value });
								validateData();
							}}
							onBlur={validateData}
						></input>
					</div>
					<div className={"newDateView"}>
						<p className={"newDateText"}>Data urodzenia</p>
						<div className="newDateViewData">
							<input
								type="date"
								onBlur={validateData}
								ref={refDate}
								aria-label="data_urodzenia"
								className="newDate"
								onChange={validateData}
								max={new Date().toJSON().split("T")[0]}
							/>
						</div>
					</div>
					<div className="newDateButtons">
						<div onClick={zapisz}>
							<button disabled={enabled} className="newDateButton">
								Zapisz
							</button>
						</div>
						<div onClick={anuluj}>
							<p className="newDateButton" style={{ color: "red" }}>
								Anuluj
							</p>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default NewDate;
